<template>
  <div class="detail-wrap" v-if="detail !== null">
    <!-- 各类详情页 -->
    <!-- 视频 -->

    <NavHeaderBar title="详情" leftArrow rightArrow :onClickRight="onClickRight" />


    <template v-if="detail.status === 0 || detail.status === 1">
      <DetailVideoPlayerContentXueHui ref="palyDomRef" :zbcode="detail.code" :zbflag="detail.zbflag"
        :url="detail.playurl" :playsafe="detail.polyv.playsafe" :cover="detail.cover" :address="detail.address"
        :source="detail.source" @onswitchquality="onswitchquality" />

      <DetailDescXueHui ref="detailDescRef" :title="detail.name" :looks="detail.clickon" :zan="detail.zbagree" :detail="detail"
        @catsource="onCatSource" />

      <!-- 各类tab -->
      <DWDetailTabsXueHui v-if="detail.status !== 3" :list="detail.zhiboFunList" />

      <!-- 登陆按钮 -->
      <DetailLoginButton v-if="!token && sysType === 'h5'" />
    </template>
  </div>
  <LoddingElement v-else />
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getEnv } from "@/config/utils";
import { Dialog } from "vant";
import share from "@/mixins/share";
import { getCorpCode } from "@/config/yqy";
import apis from "@/config/apis";

export default {
  name: "Deetailxuehui",
  mixins: [share],
  data: () => ({
    flag: 1,
    corpCode: "",
    corpName: "",
  }),
  beforeCreate: () => {
    document.title = "";
  },
  computed: {
    ...mapState({
      token: state => state.user.token,
      detail: state => state.detailxuehui.detail
    }),
    zbcode() {
      return this.$route.query.zbcode;
    },
    sysType() {
      return getEnv();
    }
  },
  watch: {
    token: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.checkIsSignUp({ isVerify: false, code: this.zbcode });
        }
      }
    },
    detail: {
      immediate: true,
      handler: function (val) {
        if (val && val.name) {
          document.title = val.name;
        }
      }
    }
  },

  created() {

    this.corpCode = getCorpCode();
    this.initTitle();
    this.getDetailNoToken(this.zbcode).then(res => {
      setTimeout(() => {
        document.title = res.name;
      }, 0);

      // 初次进入重置直播时长，进度参数
      if (getEnv() !== "h5") {
        // 获取阅读id
        let shars = {};
        shars.shareId = this.$route.query.shareId || "0";
        shars.bizId = this.$route.query.bizId || res.id;
        const { cover, sharedesc, id } = res;
        const share = res.share || res.name;
        const bizType = res.status;
        const shareimg = res.shareimg || cover;
        let url = window.location.href.split("?")[0] + "?zbcode=" + res.code;

        if (this.corpCode) {
          url = url + "&corpCode=" + this.corpCode
        }

        this.share(bizType, url, shars, shareimg, sharedesc, share, id);
      }
    });
  },
  methods: {
    ...mapActions({
      getDetailNoToken: "detailxuehui/getDetailNoToken",
      checkIsSignUp: "detailxuehui/checkIsSignUp"
    }),

    // 获取首页信息
    async initTitle() {
      try {
        const resp = await apis.common.getCorp();
        if (resp.success === "ok") {
          this.corpName = resp.data.corpName;
        }
      } catch (error) {
        console.log(error);
      }
    },


    onClickRight() {
      const { isConference, source } = this.$route.query;

      if (source && (source != 'undefined')) {
        this.$router.push({
          path: source,
          query: { project: this.detail.ocode }
        });
      }
      else if (isConference && (isConference != 'undefined')) {
        this.$router.push({
          path: "/conference",
          query: { code: this.detail.ocode }
        });
      }
      else {
        this.$router.push(
          {
            path: "/dw/",
            query: { corpCode: this.corpCode }
          });
      }
    },



    onCatSource: function (value) {
      this.$nextTick(() => {
        this.$refs.palyDomRef.onSetSource(value);
      });
    },
    onswitchquality: function (index) {
      this.$nextTick(() => {
        this.$refs.detailDescRef.onSetActive(index);
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    const zbcode = to.query.zbcode;
    const onloadTime = JSON.parse(sessionStorage.getItem(zbcode));
    const params = {
      time: Date.now(),
      flag: 1
    };
    if (!onloadTime) {
      // 当无此详情页对应zbcode的刷新次数时新增一条
      sessionStorage.setItem(zbcode, JSON.stringify(params));
      next();
    } else if (onloadTime.flag >= 5) {
      // 累计次数大于5时，做提示操作
      if (Date.now() - onloadTime.time >= 15000) {
        // 距离上一次刷新超过15秒则清空次数
        sessionStorage.setItem(zbcode, JSON.stringify(params));
        next();
      } else {
        // 超过5次且时间也不大于15秒时提示
        Dialog.alert({
          message: "请规范操作，不要反复刷新!"
        }).then(() => {
          params.flag = 5;
          sessionStorage.setItem(zbcode, JSON.stringify(params));
          next();
        });
      }
    } else if (Date.now() - onloadTime.time <= 7000) {
      // 当间隔小于7秒时，加1次数
      params.flag = onloadTime.flag + 1;
      sessionStorage.setItem(zbcode, JSON.stringify(params));
      next();
    } else {
      // 间隔正常不加次数
      params.flag = onloadTime.flag;
      sessionStorage.setItem(zbcode, JSON.stringify(params));
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.corpName) {
      document.title = this.corpName
    }
    this.$store.commit("detailxuehui/RESET");
    this.$store.commit("im/RESET_IM_LIST");
    this.$destroy();
    next();
  }
};
</script>

<style lang="scss">
.detail-wrap {
  .van-skeleton__row {
    height: 40px;
  }

  padding-top: 46px;
}
</style>
